<template>
  <div class="errortips datang">
    <h4>数据加载失败</h4>
    <p>请检查您的手机是否联网,点击按钮重新加载</p>
    <a href="javascript:;" :class="{'hover':activeClass}" @click="clickEvent" @touchstart="addActive" @touchmove="addActive" @touchend="removeActive">重新加载</a>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      activeClass: false
    }
  },
  created(){
    var that = this;
    window.Back.reset();
    window.Back.push(function () {
      window.location.href = 'daojia://finish';
    });
  },
  ready() {
    var that = this;
    document.body.style.backgroundColor = '#fff';
  },
  methods: {
    clickEvent() {
      location.reload();
    },
    addActive() {
      this.activeClass = true
    },
    removeActive() {
      this.activeClass = false
    }
  }
}
</script>
<style scoped>
.errortips {
  text-align: center;
  padding-top: 80px;
}

.errortips:before {
  content: "";
  display: block;
  height: 100px;
  width: 100px;
  background: url(http://static.daojia.com/fe/h5/djh5/css/img/ico-tips-gray_c1bd6a8.png) no-repeat;
  background-size: 204px auto;
  margin: 0 auto 15px;
}

.errortips h4 {
  font-weight: normal;
  font-size: 18px;
  color: #292d33;
  margin-bottom: 12px;
}

.errortips p {
  color: #848d99;
  font-size: 13px;
  line-height: 18px;
}

.errortips a {
  background: #fff;
  border: 1px solid #e6454a;
  border-radius: 21px;
  font-size: 22px;
  height: 42px;
  line-height: 42px;
  padding: 0 36px;
  display: inline-block;
  font-size: 19px;
  color: #e6454a;
  margin-top: 20px;
}

.errortips a.hover {
  color: #fff;
  background: #e6454a;
}
</style>



// WEBPACK FOOTER //
// Error.vue?1acd625b